'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Tabs = require('material-ui/Tabs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      slideIndex: 0
    };

    _this.tabs = props.items.map(_this.getTab);

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'getTab',
    value: function getTab(tab, index) {
      var component = tab.component,
          title = tab.title,
          label = tab.label,
          others = _objectWithoutProperties(tab, ['component', 'title', 'label']);

      var Component = tab.component;
      return _react2.default.createElement(
        _Tabs.Tab,
        _extends({}, others, { label: title || label, value: index }),
        _react2.default.createElement(
          'div',
          { key: index },
          Component ? _react2.default.createElement(Component, null) : tab.element
        )
      );
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      this.setState({
        slideIndex: value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Tabs.Tabs,
        _extends({
          onChange: this.handleChange,
          value: this.state.slideIndex,
          style: { marginBottom: '20px' }
        }, this.props),
        this.tabs
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  items: _react2.default.PropTypes.array.isRequired
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Tabs/Tabs.js
 ** module id = 503
 ** module chunks = 0
 **/